import styled from 'styled-components';

const TitleText = styled.div`
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 800px) {
    width: 200px;
    white-space: wrap;
  }
`;

export default TitleText;
